export default class ClientAccountingUtil {
    static convertToPositiveNumber(amount) {
        return +Math.abs(amount);
    }

    static convertToNegativeNumber(amount) {
        return -Math.abs(amount);
    }
}